/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.35
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from "../ApiClient";
import {ChecklistPeriodDTO} from '../model/ChecklistPeriodDTO';
import {RestBodyResponseUtil} from '../model/RestBodyResponseUtil';

/**
* ChecklistPeriodService service.
* @module api/ChecklistPeriodServiceApi
* @version v0
*/
export class ChecklistPeriodServiceApi {

    /**
    * Constructs a new ChecklistPeriodServiceApi. 
    * @alias module:api/ChecklistPeriodServiceApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instanc
    e} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }

    /**
     * Callback function to receive the result of the getAllChecklistPeriods operation.
     * @callback moduleapi/ChecklistPeriodServiceApi~getAllChecklistPeriodsCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/ChecklistPeriodDTO>{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get checklist period
     * Request to get all the checklist periods
     * @param {module:api/ChecklistPeriodServiceApi~getAllChecklistPeriodsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    getAllChecklistPeriods(callback) {
      
      let postBody = null;

      let pathParams = {
        
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['*/*'];
      let returnType = [ChecklistPeriodDTO];

      return this.apiClient.callApi(
        '/api/checklist-period', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

}